<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table"><slot></slot></h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content">
      <el-form label-width="100px" v-if="!$isMobile()">
        <el-row>
          <el-col :span="6" :xs="24">
            <el-form-item :label="$t('messages.lblUserName')">{{
              form.data.userNm
            }}</el-form-item>
          </el-col>
          <el-col :span="7" :xs="24">
            <el-form-item :label="$t('messages.lblUserType')">{{
              form.data.userTypeNm
            }}</el-form-item>
          </el-col>
          <el-col :span="11" :xs="24">
            <el-form-item :label="$t('messages.lblDepartment')">{{
              form.data.deptNm
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :xs="24">
            <el-form-item :label="$t('messages.lblPosition')">{{
              form.data.clposCd
            }}</el-form-item>
          </el-col>
          <el-col :span="7" :xs="24">
            <el-form-item :label="$t('messages.lblContact')">{{
              form.data.hp
            }}</el-form-item>
          </el-col>
          <el-col :span="11" :xs="24">
            <el-form-item :label="$t('messages.lblEmail')">{{
              form.data.email
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form v-else>
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblUserName')">{{
              form.data.userNm
            }}</el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblUserType')">{{
              form.data.userTypeNm
            }}</el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblDepartment')">{{
              form.data.deptNm
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblPosition')">{{
              form.data.clposCd
            }}</el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblContact')">{{
              form.data.hp
            }}</el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblEmail')">{{
              form.data.email
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
  </div>
</template>

<script>
export default {
  props: {
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      currPrcssTrtDataCnctId: "",
      form: {
        data: {
          userNm: "",
          userType: "",
          deptNm: "",
          clposCd: "",
          hp: "",
          email: "",
        },
      },
    };
  },
  created() {
    //this.getWrkRcpOpinRetv();
  },
  mounted() {
    // if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
    //   this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId
    if(!this.isTemplate){
      this.setReqData();
    }
    // }
  },
  watch: {
    prcssTrtDataCnctId() {
      // if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
      //   this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId
      this.setReqData();
      // }
    },
    isWrite(){
      this.setReqData();
    }
  },
  methods: {
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    setReqData() {
      this.form.data.userNm = this.ticketInfo.asgnrNm;

      if (this.ticketInfo.asgnrTypeCd == 0) {
        this.form.data.userType = "";
      } else {
        this.form.data.userType = this.ticketInfo.asgnrTypeCd;
      }

      this.form.data.deptNm = this.ticketInfo.asgnrPosDept;
      this.form.data.clposCd = this.ticketInfo.asgnrRspof;
      this.form.data.hp = this.ticketInfo.asgnrCntplc;
      this.form.data.email = this.ticketInfo.asgnrEmail;
    },
    getWrkRcpOpinRetv() {
      this.$BIZ_SERVICE
        .post(this.scrnGetApi, {
          prcssTrtDataCnctId: this.currPrcssTrtDataCnctId,
        })
        .then((res) => {
          if (res.data !== "" && res.data.resData != null) {
            this.form.data = res.data.resData;
          } else {
            this.form.data = {};
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    chkValidateData() {
      return true;
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.form.data;
    },
  },
};
</script>
<style lang="scss" scoped></style>
